/**
 * @description Gestion du comportement du bloc "démarches rapides"
 */

/* global bsBreakpoints */

(() => {
	// VARIABLES
	const demarchesBloc = document.querySelector('.services__demarches');
	const demarchesButton = demarchesBloc.querySelector(
		'.demarches__open-button'
	);
	const demarchesClose = demarchesBloc.querySelector(
		'.demarches__close-button'
	);
	const demarchesLink = document.querySelector('.demarches__link') || null;

	const navKeyboard = () => {
		demarchesBloc.addEventListener('keydown', (e) => {
			if (e.key === 'Enter') {
				demarchesBloc.classList.add('services__demarches--keyboard');
				demarchesButton.setAttribute('aria-expanded', true);
			} else if (e.key === 'Escape') {
				demarchesBloc.classList.remove('services__demarches--keyboard');
				demarchesButton.setAttribute('aria-expanded', false);
			}
		});
		demarchesBloc.addEventListener('mouseover', (e) => {
			demarchesBloc.classList.remove('services__demarches--a11y');
			demarchesBloc.setAttribute('tabindex', '-1');
			demarchesBloc.focus();
			const prevEl = demarchesBloc.previousElementSibling;
			const nextEl = demarchesBloc.nextElementSibling;
			const keyboardNextElement = [
				...nextEl.querySelectorAll(
					'a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
				),
			].filter(
				(el) =>
					!el.hasAttribute('disabled') &&
					!el.getAttribute('aria-hidden')
			);
			const keyboardPrevElement = [
				...prevEl.querySelectorAll(
					'a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
				),
			].filter(
				(el) =>
					!el.hasAttribute('disabled') &&
					!el.getAttribute('aria-hidden')
			);
			demarchesBloc.addEventListener('keydown', (e) => {
				e.preventDefault();
				if (e.key === 'Escape') {
					demarchesBloc.classList.add('services__demarches--a11y');

					keyboardNextElement[0].focus();
				}
				if (e.key === 'Enter') {
					demarchesBloc.classList.remove('services__demarches--a11y');
				}
				if (e.keyCode === 9) {
					if (e.shiftKey) {
						keyboardPrevElement[0].focus();
					} else {
						keyboardNextElement[0].focus();
					}
				}
			});
		});
		if (demarchesLink) {
			demarchesLink.addEventListener('keydown', (e) => {
				if (e.key === 'Tab') {
					demarchesBloc.classList.remove(
						'services__demarches--keyboard'
					);
					demarchesButton.setAttribute('aria-expanded', false);
				}
			});
		}
	};

	// FONCTIONS
	// Menu responsive
	const demarchesRwd = () => {
		if (
			bsBreakpoints.detectBreakpoint() === 'xSmall' ||
			bsBreakpoints.detectBreakpoint() === 'small' ||
			bsBreakpoints.detectBreakpoint() === 'medium'
		) {
			demarchesButton.addEventListener('click', () => {
				demarchesBloc.classList.add('active');
				demarchesButton.tabIndex = -1;
				keyboardNavigation(
					document.querySelector('.services__demarches.active')
				);
				demarchesBloc
					.querySelector('.demarches__open-button')
					.setAttribute('aria-expanded', 'true');
			});
		}
	};

	const keyboardNavigation = (e) => {
		const focusableElements =
			'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
		const firstFocusableElement = e.querySelectorAll(focusableElements)[0]; // get first element to be focused inside bloc
		const focusableContent = e.querySelectorAll(focusableElements);
		const lastFocusableElement =
			focusableContent[focusableContent.length - 1]; // get last element to be focused inside bloc

		document.addEventListener('keydown', function (e) {
			const isTabPressed = e.key === 'Tab';

			if (!isTabPressed) {
				return;
			}

			if (e.shiftKey) {
				// if shift key pressed for shift + tab combination
				if (document.activeElement === firstFocusableElement) {
					lastFocusableElement.focus(); // add focus for the last focusable element
					e.preventDefault();
				}
			} else {
				// if tab key is pressed
				if (document.activeElement === lastFocusableElement) {
					// if focused has reached to last focusable element then focus first focusable element after pressing tab
					firstFocusableElement.focus(); // add focus for the first focusable element
					e.preventDefault();
				}
			}
		});

		firstFocusableElement.focus();
	};

	const outsideClick = (event, notelem) => {
		// check outside click for multiple elements
		let clickedOut = true;
		let i;
		const len = notelem.length;
		for (i = 0; i < len; i++) {
			if (
				event.target === notelem[i] ||
				notelem[i].contains(event.target)
			) {
				clickedOut = false;
			}
		}
		if (clickedOut) return true;
		else return false;
	};

	// Ferme le bloc démarches rapides
	const demarchesRwdClose = () => {
		demarchesClose.addEventListener('click', () => {
			demarchesBloc.classList.remove(
				'services__demarches--keyboard',
				'active'
			);
			demarchesButton.tabIndex = 0;
			demarchesButton.setAttribute('aria-expanded', false);
		});

		document.addEventListener('click', (e) => {
			if (outsideClick(e, [demarchesBloc, demarchesButton])) {
				demarchesBloc.classList.remove(
					'services__demarches--keyboard',
					'active'
				);
				demarchesButton.tabIndex = 0;
				demarchesButton.setAttribute('aria-expanded', false);
			}
		});
	};

	// GO 🚀
	const init = () => {
		window.addEventListener('resize', () => {
			demarchesRwd();
		});
		demarchesRwd();
		demarchesRwdClose();
		navKeyboard();
	};
	init();
})();
